/*
 * @prop --component-leadtext-color: Color of leadtext
 * @prop --component-leadtext-color-link: Color of links inside leadtext
 * @prop --component-leadtext-color-link-hover: Hover color of links inside leadtext
 * @prop --component-leadtext-font-family: The font family of the leadtext
*/

ui-leadtext {
  display: block;
  color: var(--component-leadtext-color, var(--current-color-text, $ui-dark));
  font-family: var(
    --component-leadtext-font-family,
    var(--skin-font-family-primary, $font-family-sans-serif)
  );
  font-size: 24px;
  font-weight: $font-weight-normal;
  line-height: 32px;
  word-break: break-word;

  a {
    color: var(
      --component-leadtext-color-link,
      var(--current-color-primary, $ui-blue)
    );
    cursor: pointer;
    text-decoration: underline;
    text-decoration-color: var(
      --component-leadtext-color-link,
      var(--current-color-primary, $ui-blue)
    );

    &:hover {
      color: var(
        --component-leadtext-color-link-hover,
        var(--current-color-primary-light, $ui-blue-minus-1)
      );
      text-decoration-color: var(
        --component-leadtext-color-link-hover,
        var(--current-color-primary-light, $ui-blue-minus-1)
      );
    }
  }

  ui-paragraph,
  p {
    margin-bottom: 0;
    margin-top: 8px;

    &:first-child {
      margin-top: 0;
    }
  }

  mark {
    @extend %mark;
  }
}

ui-leadtext[variant='white'] {
  color: var(--skin-color-white, $ui-white);

  a {
    color: var(--skin-color-white, $ui-white);

    &:hover {
      color: var(--skin-color-primary-light, $ui-blue-minus-1);
    }
  }
}
